import { Component, OnInit, ViewChild } from '@angular/core';
// 1. Update Ionic imports to the modern path!
import { IonContent, IonicModule } from '@ionic/angular'; 
import { IonMenu } from '@ionic/angular';
import { Platform, AlertController } from '@ionic/angular'; 
// import { StatusBar } from '@ionic-native/status-bar/ngx'; // Make sure plugins use /ngx
import { Router, RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router'; 

// 2. Remove Nav and Events imports (Navigation handled by Angular Router)

import { HomePage } from '../pages/home/home';
import { WishlistPage } from '../pages/wishlist/wishlist';
import { AnalysesPage } from '../pages/analyses/analyses';
import { AuthPage } from '../pages/auth/auth';
import { FaqPage } from '../pages/faq/faq';

import { Network } from '@ionic-native/network/ngx'; // Make sure plugin uses /ngx

import { TranslateService } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { addIcons } from 'ionicons'; 

@Component({
  selector: 'app-root', // Added selector for modern component definition
  templateUrl: 'app.html',
  styleUrls: ['./app.scss'],
  standalone: false,
  imports: [
    CommonModule,
    IonicModule,
    FormsModule,
    TranslateModule,
    RouterOutlet,
    RouterLink,
    RouterLinkActive
//    IonRouterOutlet
  ]
})

// 3. Implement OnInit to handle logic after component initialization
export class MyApp implements OnInit {
  
  @ViewChild(IonMenu) menu: IonMenu;
  // @ViewChild(Nav) nav: Nav; // REMOVED - Replaced by Angular Router

  // This structure is for the side menu/drawer, which still needs defining.
  // In modern apps, this menu is usually implemented using <ion-menu> tags inside app.html.
  pages: Array<{ title: String, component: any, iconName: String }>;

  noInternetConnenctionPopUp: any;
  
  // If you are using Angular Router for navigation, you inject Router, not Nav
  // If you *must* keep the navigation logic here, you need to inject Angular's Router service.
  
  constructor(
    private platform: Platform,
//    private statusBar: StatusBar,
    private alertCtrl: AlertController,
    private translateService: TranslateService,
    private network: Network,
    private router: Router
  ) {
    // Initialization logic that doesn't depend on platform being ready
    this.log('Initialization phase complete');

    // 2. REGISTER YOUR CUSTOM ICONS HERE
    // The key is the 'name' you used in HTML (e.g. name="beerhive-icon")
    // The value is the path to the file
    addIcons({
      'beerhive-icon': 'assets/svg/icon_beerhive.svg',
      'beerhive-icon-bee': 'assets/svg/icon_bee.svg',
      'beerhive-icon-menu-myanalysis': 'assets/svg/icon_menu_myAnalysis_2.svg',
      'beerhive-icon-menu-wishlist': 'assets/svg/icon_wishlist_menu.svg',
      'beerhive-icon-sight': 'assets/svg/icon_sight.svg',
      'beerhive-icon-menu-faq': 'assets/svg/icon_menu_faq.svg',
      'beerhive-icon-menu-logout': 'assets/svg/icon_menu_logout.svg',
      'beerhive-icon-venue-filter-0': 'assets/svg/icon_location_0.svg',
      'beerhive-icon-venue-filter-1': 'assets/svg/icon_location_1.svg'
    });
  }

  ngOnInit(): void {
    // Logic that MUST wait for the platform to be ready goes here
    this.platform.ready().then(() => {
      this.log('the platform is ready');

      this.setupNetworkWatch();
      this.setupLanguage().subscribe(() => {
        this.setupMenu();
      });

      // Okay, so the platform is ready and our plugins are available.
      // this.statusBar.styleDefault();
    });
  }
  
  // Moved platform-ready specific logic into dedicated methods for clarity
  private setupNetworkWatch() {
      // watch network for a disconnect
      this.network.onDisconnect().subscribe(() => {
        console.log('network was disconnected :-(');
        this.presentInternetProblem();
      });

      // watch network for a connection
      this.network.onConnect().subscribe(() => {
        console.log('network connected!');
        this.dismissInternetProblem();
      });
  }

  private setupLanguage() {
      this.translateService.addLangs(['en', 'nl']);
      this.translateService.setDefaultLang('nl');

      let browserLang = this.translateService.getBrowserLang();
      console.log("MyApp: browser language = " + browserLang);
      return this.translateService.use(browserLang.match(/en|nl/) ? browserLang : 'en');
  }

  private setupMenu() {
    this.translateService.get(['MENU']).subscribe(translations => {
      console.log("MyApp: MENU.MY_ANALYSES = " + this.translateService.get("MENU.MY_ANALYSES"));
      this.pages= [
        { title: translations.MENU.HOME, component: HomePage, iconName: "beerhive-icon" },
        { title: translations.MENU.MY_ANALYSES, component: AnalysesPage, iconName: "beerhive-icon-menu-myanalysis" },
        { title: translations.MENU.WISHLIST, component: WishlistPage, iconName: "beerhive-icon-menu-wishlist" },
        { title: translations.MENU.FAQS, component: FaqPage, iconName: "beerhive-icon-menu-faq" },
        { title: translations.MENU.LOG_OUT, component: AuthPage, iconName: "beerhive-icon-menu-logout" }
      ];
    });
  }

  // 4. Navigation Logic needs complete overhaul if you are using Angular Router!
  // If this component handles the main menu inside an <ion-menu>, this function might need to trigger routing instead of .setRoot()
  public openPage(page) {
    console.log("MyApp: opening page " + page.component.PATH);

    this.menu.isActive().then((isActive) => {
      if (isActive) {
        this.menu.close(false);
      }
    });
    console.log("MyApp: navigating to " + page.component.PATH);
    this.router.navigate([ page.component.PATH ]);
    // ***** CRITICAL: Replaced old Nav logic with desired modern structure *****
    // Since you likely moved to Angular Routing, you should inject Router and use router.navigate
    // If you MUST retain the old 'Nav' structure, you need to include Nav in your constructor/providers
    
    // Placeholder: If you are using the modern structure, this function might not belong here, 
    // or it needs to interact with an Angular Breadcrumb/Router outlet structure.
    // console.log("Navigation logic needs updating to use Angular Router instead of Nav.");
    // Example if sticking to old Nav: this.nav.setRoot(page.component); 
   }

  public showHomePage() {
    // This direct call relies on 'openPage' working, which currently won't work without 'Nav'
    this.openPage({ component: HomePage }); 
  }

  log(s: string) {
    console.log("MyApp - " + s);
  }

  private presentInternetProblem() {
    // Use modern Ionic AlertController usage if possible, or stick to this way if it works
    this.noInternetConnenctionPopUp = this.alertCtrl.create({
      header: this.translateService.instant('GENERAL.NO_INTERNET_CONNECTION'),
      message: this.translateService.instant('GENERAL.PLEASE_CONNECT_TO_THE_INTERNET_TO_CONTINUE'),
      buttons: []
    });
    this.noInternetConnenctionPopUp.present();
  }

  private dismissInternetProblem() {
    // Check if the popup object exists before attempting to dismiss
    if (this.noInternetConnenctionPopUp) {
        this.noInternetConnenctionPopUp.dismiss()
    }
  }
}